/* eslint-disable no-undef */
(function ($) {
	// The parallax scroll for images.
	$(document).ready(function () {
		$(window).on('load scroll resize', function () {
			const parallaxElement = $('.ncos-cover__media'),
				parallaxQuantity = parallaxElement.length;

			if ($(window).width() > 984) {
				window.requestAnimationFrame(function () {
					for (let i = 0; i < parallaxQuantity; i++) {
						const currentElement = parallaxElement.eq(i),
							windowTop = $(window).scrollTop(),
							elementTop = currentElement.offset().top,
							elementHeight = currentElement.height(),
							viewPortHeight = window.innerHeight * 1.2 - elementHeight * 0.5,
							scrolled = windowTop - elementTop + viewPortHeight;
						currentElement.css({
							transform: 'translate3d(0,' + scrolled * -0.15 + 'px, 0)',
						});
					}
				});
			} else {
				for (let i = 0; i < parallaxQuantity; i++) {
					parallaxElement.eq(i).css('transform', 'none');
				}
			}
		});
	});

	// The text animations.
	$(document).ready(function () {
		/**
		 * == Splitting Text
		 */

		/**
		 * Start the text split
		 */
		const coverH2 = document.querySelectorAll('.ncos-cover__heading');
		const text = [];

		coverH2.forEach(function (e) {
			text.push(
				SplitType.create(e, {
					types: 'lines, words',
					lineClass: 'ncos-cover__heading__line',
				})
			);
		});

		/**
		 * Mark each line as ready for animation
		 */
		$('.ncos-cover__heading__line').each(function () {
			$(this).addClass('before-animate');
		});

		/**
		 * Kick things off line by line
		 */
		const covers = $('.ncos-cover');

		covers.each(function () {
			const $cover = $(this);
			$(window).on('load scroll', function () {
				if (isOnScreen($cover)) {
					// Release the mask.
					$cover.addClass('ncos-cover--is-revealed');

					// Fly the heading in.
					$cover.find('.ncos-cover__heading__line').each(function (i) {
						const $heading = $(this);

						if ($heading.hasClass('animate')) {
							return false;
						}

						setTimeout(function () {
							$heading.addClass('animate');
						}, i * 250); // milliseconds
					});
				}
			});
		});

		/**
		 * == When the doc is ready, change H1 to opaque
		 */
		$('.ncos-cover__heading').css('opacity', 1);

		/**
		 * Handle window resize
		 */
		const $windowWidth = $(window).width();
		$(window).on('resize', function () {
			// Refresh the line split. Only horizontal resize.
			if ($windowWidth !== $(window).width()) {
				text.forEach(function (e) {
					e.split();
				});
			}

			// Prevent the text from animating on the resize.
			$('.ncos-cover__heading__line').each(function () {
				$(this).addClass('after-animate');
			});
		});
	});
})(jQuery);

function isOnScreen(elem) {
	// if the element doesn't exist, abort
	if (elem.length === 0) {
		return;
	}
	const $window = jQuery(window);
	const viewport_top = $window.scrollTop();
	const viewport_height = $window.height();
	const viewport_bottom = viewport_top + viewport_height;
	const $elem = jQuery(elem);
	const top = $elem.offset().top;
	const height = $elem.height();
	const bottom = top + height;

	return (
		(top >= viewport_top && top < viewport_bottom) ||
		(bottom > viewport_top && bottom <= viewport_bottom) ||
		(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
	);
}
